import React, { useEffect } from 'react';
import Anime from 'react-anime';
import BackToHomeBtn from './BackToHomeBtn';
import {writingsData } from '../data/data';
import '../styles/WritingsPage.css';

const ArticleList = props => {
  return(
    <ul>
      {props.articleList.map(article => 
        <li>
          <a href={article.link} target="_blank">{article.title}</a>
          <br/>
          <span>{article.publishedOn}</span>
        </li>
      )}
    </ul>
  )
}

const WritingsPage = props => {

  useEffect(() => {
      const style = document.createElement("style");
      style.innerHTML = `
        .custom-scroll::-webkit-scrollbar {
          height: 4px;
          background: transparent;
          border-radius: 4px; /* Rounds the scrollbar itself */
        }
        .custom-scroll::-webkit-scrollbar-thumb {
          background: white;
          border-radius: 20px; /* Rounds the scrollbar handle */
        }
      `;
      document.head.appendChild(style);
    
      return () => {
        document.head.removeChild(style); // Cleanup on unmount
      };
    }, []);

  return(
    //Making the page stop scrolling
    <div style={{ 
      overflow: "hidden",
      position: "fixed",

     
    }}>
    <div className="page-back-btn">
      <BackToHomeBtn handleClick={props.returnBtn} />
    </div>
    <Anime easing="easeOutCubic" opacity={[0, 1]} translateY={-30} duration={400} delay={300}>
      <div className="writings-page">
      <Anime easing="easeOutCubic" opacity={[0, 1]} duration={500} delay={800}>
  <p className="page-tag">Writings</p>
</Anime>
           {/* Internal scoll start */}
<div className="about-scroll" style={{ height: 'calc(100vh - 200px)', overflow: 'scroll', overflowX: 'hidden', scrollbarWidth: 'thin', scrollbarColor: 'rgba(255, 253, 253, 0.5) transparent' }}>
              {/* Your content here */}

            <div className="page-content">
              <h1>I love to write about my experiences!</h1>
              <p className="page-intro">One of the reasons behind loving the development community so much is peoples mindset for giving away valuable resources and insights for free. I've read and benefitted from countless numbers of articles online. Writing articles about technology and experience is my way of giving back to the community. As a bonus, it's also a great way to solidifying my own learning. 
                <br/>
              Below are some of the articles I've written recently.</p>
              <div className="article-list">
                <ArticleList articleList={writingsData}/>
              </div>
              </div>
            </div>
        
      </div>
    </Anime>
    </div>
  )
}

export default WritingsPage;